module.exports = __webpack_public_path__ + "static/media/icon-team-personality-medium.592af673.svg";